<template>
  <v-container class="ma-0 pa-0 mw-100">
    <validation-dialog
      :title="$t('AdminPage.delete_user')"
      :content="$t('AdminPage.delete_user_content')"
      :dialog="deleteUserDialog"
      @close="deleteUserDialog = false"
      @done="deleteUser"
      :buttons="[$t('Headers.cancel'), $t('Headers.delete')]"
    />
    <validation-dialog
      :title="$t('AdminPage.delete_user')"
      :content="$t('AdminPage.delete_users_content')"
      :dialog="deleteMultipleUsersDialog"
      @close="deleteMultipleUsersDialog = false"
      @done="deleteMultipleUser"
      :buttons="[$t('Headers.cancel'), $t('Headers.delete')]"
    />
    <v-dialog v-model="editUserDialog" max-width="600px">
      <v-card>
        <v-card-title v-text="$t('AdminPage.Role')" />
        <v-card-text>
          <v-select
            filled
            :label="$t('AdminPage.Role')"
            v-model="newRole"
            :items="roles"
            required
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            :text="$t('Headers.close')"
            @click="
              (editUserDialog = false),
                (editUserRole = ''),
                (editUserObject = '');
            "
          />
          <custom-button
            :text="$t('Headers.save')"
            @click="(editUserDialog = false), editUserRole();"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container class="ma-0 pa-0 mw-100" v-if="showTable">
      <custom-table
        :search="search"
        :items="items"
        :headers="headers"
        @edit="editUser($event)"
        @deleteUserD="deleteUserD"
        @delete="deleteMultilpeUsersD"
      />
    </v-container>
  </v-container>
</template>

<script>
import i18n from "@/i18n";
import ValidationDialog from "../../components/ui/other/ValidationDialog";
import CustomTable from "../../components/ui/other/CustomTable";
import CustomButton from "../../components/ui/input/CustomButton";
import { log } from "@/helpers/logger";

/**
 * @vue-data {Array} users - table content
 * @vue-data {String} search - search line input
 * @vue-data {String} selected_user - stores the user_id for the selected user
 * @vue-data {Dictionary} user_form_input - input in the user form
 * @vue-data {Boolean}[deleteMultipleUsersDialog=false] deleteMultipleUsersDialog - gives, if delete multiple users validation dialog is displayed
 * @vue-data {Boolean}[deleteUserDialog=false] deleteUserDialog - gives, if delete user validation dialog is displayed
 * @vue-data {Array} selectedItems - stores the selected rows
 * @vue-data {Boolean}[editDialog=false] editDialog - gives, if edit validation dialog is displayed
 * @vue-data {Boolean}[showTable=true] showTable - gives, if table is displayed
 * @vue-data {Array} selected_users - stores the selected rows
 * @vue-method {} setUsers() - stores the user data
 * @vue-method {String} deleteMultilpeUsersD(users) - stores selected users
 * @vue-method {} deleteMultipleUser() - deletes user from DB
 * @vue-method {String} editUser(user) - stores edited user data in DB
 * @vue-method {} closeUserForm() - closes user form and resets data
 * @vue-method {String} deleteUserD(user) - stores user, which should be deleted
 * @vue-method {} deleteUser() - deletes user from DB
 */
export default {
  name: "user",
  title: i18n.t("HomePage.header.admin"),
  props: {
    items: Array,
  },
  components: {
    ValidationDialog,
    CustomTable,
    CustomButton,
  },
  data() {
    return {
      search: "",
      newRole: "",
      editUserObject: "",
      user_form_input: {},
      selected_user: null,
      deleteMultipleUsersDialog: false,
      deleteUserDialog: false,
      editUserDialog: false,
      editDialog: false,
      showTable: true,
      selected_users: [],
      selectedItems: [],
      headers: [
        {
          value: "first_name",
          text: i18n.t("AdminPage.Firstname"),
          sortable: true,
        },
        {
          value: "last_name",
          text: i18n.t("AdminPage.Lastname"),
          sortable: true,
        },
        {
          value: "e_mail",
          text: i18n.t("AdminPage.Email"),
          sortable: true,
        },
        {
          value: "phone",
          text: i18n.t("AdminPage.Telephone"),
          sortable: true,
        },
        {
          value: "account_role_text",
          text: i18n.t("AdminPage.Role"),
          sortable: false,
        },
        {
          value: "actions",
          text: "",
          sortable: false,
        },
        {
          value: "delete",
          text: "",
          sortable: false,
        },
      ],
      roles: [
        {
          value: "admin",
          text: this.$t("AdminPage.AdminRole"),
        },
        {
          value: "user",
          text: this.$t("AdminPage.UserRole"),
        },
      ],
    };
  },
  watch: {
    items() {},
  },
  created() {
    this.setUsers();
    this.$store.commit("set_loading", false);
  },
  methods: {
    setUsers() {
      let items_temp;
      if (!Array.isArray(this.items)) {
        items_temp[0] = this.items;
      } else {
        items_temp = this.items;
      }
      items_temp.forEach((us) => {
        us.dropdown_items = [];

        us.dropdown_items.push({
          textButton: false,
          title: "Bearbeiten",
          function: "edit",
          icon: "mdi-pencil",
          key: "edit",
          column: "actions",
        });
      });
      this.items = items_temp;
    },
    deleteMultilpeUsersD(users) {
      this.deleteMultipleUsersDialog = true;
      this.selected_users = users;
    },
    deleteMultipleUser() {
      for (let s in this.selected_users) {
        this.$store
          .dispatch("data/deleteUser", this.selected_users[s])
          .finally(() => {
            log(
              "AdminPage.Users.deleteMultipleUser() - delete user " +
                this.selected_users[s].id,
              "info"
            );
            this.setUsers();
            location.reload();
          })
          .catch((err) => {
            log("AdminPage.Users.deleteMultipleUser() - " + err, "error");
          });
      }
      this.selected_users = [];
      this.deleteMultipleUsersDialog = false;
    },
    editUser(user) {
      this.newRole = user.account_role;
      this.editUserObject = user;
      this.editUserDialog = true;
    },
    editUserRole() {
      var temp = {
        changingAdminId: this.$store.state.auth.user.id,
        administrator: this.editUserObject,
      };
      temp.administrator.account_role = this.newRole;
      this.$store
        .dispatch("data/updateAccountAdministratorRole", temp)
        .then(() => {
          log(
            "AdminPage.Users.editUserRole() - update Account Administrator Role " +
              temp.administrator.id,
            "info"
          );
          location.reload();
        })
        .catch((err) => {
          log("AdminPage.Users.editUserRole() - " + err, "error");
          this.editUserObject = "";
          this.editUserRole = "";
          this.$emit("close");
          location.reload();
        });
    },
    closeUserForm() {
      this.$router.push("/Admin");
      this.editDialog = false;
      this.user_form_input = {};
      this.$store
        .dispatch("data/getUsers")
        .then(() => {
          log("AdminPage.Users.closeUserForm() - get users", "info");
          this.users_loaded = true;
          this.setUsers();
        })
        .catch((err) => {
          log("AdminPage.Users.closeUserForm() - " + err, "error");
        });
      this.showTable = true;
    },
    deleteUserD(user) {
      this.deleteUserDialog = true;
      this.selected_user = user;
    },
    deleteUser() {
      this.$store
        .dispatch("data/deleteUser", this.selected_user.user_id)
        .finally(() => {
          log(
            "AdminPage.Users.deleteUser() - delete user " +
              this.selected_user.user_id,
            "info"
          );
          this.deleteUserDialog = false;
          this.setUsers();
          location.reload();
        })
        .catch((err) => {
          log("AdminPage.Users.deleteUser() - " + err, "error");
        });
    },
  },
};
</script>
